module.exports = {"Retirement4":{"daobanList":[{"title":"1:残疾人服务一件事","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、广东省残疾人服务“一件事”申请表","state":"必要"},{"name":"2、居民身份证","state":"必要"},{"name":"3、居民户口簿","state":"必要"},{"name":"4、照片","state":"必要"},{"name":"5、监护人身份证、户口簿等具有法律效力的证明材料","state":"非必要"},{"name":"6、经常居住地的有效居住证","state":"非必要"},{"name":"7、中华人民共和国残疾人证","state":"必要"},{"name":"8、死亡证明","state":"必要"},{"name":"9、社会保障卡","state":"必要"},{"name":"10、广东省城乡居民最低生活保障证","state":"必要"},{"name":"11、城乡居民养老保险业务办理委托函","state":"必要"}]},{"name":"否","xuanzhong":0,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdr-4.json
// module id = 1294
// module chunks = 0